import { render, staticRenderFns } from "./WeekHours.vue?vue&type=template&id=178876dd&scoped=true&"
import script from "./WeekHours.vue?vue&type=script&lang=ts&"
export * from "./WeekHours.vue?vue&type=script&lang=ts&"
import style0 from "./WeekHours.vue?vue&type=style&index=0&id=178876dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178876dd",
  null
  
)

export default component.exports